



























































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import gaCustomLinks from '@/utils/gaCustomLinks'

@Component
export default class Help extends Vue {
  @Getter('currentTheme') private theme!: Theme
  @Getter('currentLang') private getterLang!: Language

  get emqWebsite(): string {
    return gaCustomLinks(this.getterLang).EMQSite
  }

  get mqttxWebsite(): string {
    return gaCustomLinks(this.getterLang).MQTTXSite
  }

  get blogUtm(): string {
    return gaCustomLinks(this.getterLang).help.blogUtm
  }

  get helpTop() {
    const { learnMQTT, publicMqttBroker, mqtt5 } = gaCustomLinks(this.getterLang).help
    return [
      {
        icon: 'icon-learn-mqtt',
        title: this.$tc('help.learn'),
        link: learnMQTT,
      },
      {
        icon: 'icon-public-mqtt-broker',
        title: this.$tc('help.publicMqttBroker'),
        link: publicMqttBroker,
      },
      {
        icon: 'icon-mqtt5',
        title: this.$tc('help.mqtt5Explore'),
        link: mqtt5,
      },
    ]
  }

  get helpGuide() {
    return [
      {
        title: this.$tc('help.guideArticle1'),
        link: `${this.emqWebsite}/blog/what-is-the-mqtt-protocol`,
      },
      {
        title: this.$tc('help.guideArticle2'),
        link: `${this.emqWebsite}/blog/the-easiest-guide-to-getting-started-with-mqtt`,
      },
      {
        title: this.$tc('help.guideArticle3'),
        link: `${this.emqWebsite}/blog/mqtt-5-introduction-to-publish-subscribe-model`,
      },
      {
        title: this.$tc('help.guideArticle4'),
        link: `${this.emqWebsite}/blog/how-to-set-parameters-when-establishing-an-mqtt-connection`,
      },
      {
        title: this.$tc('help.guideArticle5'),
        link: `${this.emqWebsite}/blog/advanced-features-of-mqtt-topics`,
      },
      {
        title: this.$tc('help.guideArticle6'),
        link: `${this.emqWebsite}/blog/mqtt-session`,
      },
      {
        title: this.$tc('help.guideArticle7'),
        link: `${this.emqWebsite}/blog/introduction-to-mqtt-qos`,
      },
      {
        title: this.$tc('help.guideArticle8'),
        link: `${this.emqWebsite}/blog/mqtt5-features-retain-message`,
      },
      {
        title: this.$tc('help.guideArticle9'),
        link: `${this.emqWebsite}/blog/use-of-mqtt-will-message`,
      },
      {
        title: this.$tc('help.guideArticle10'),
        link: `${this.emqWebsite}/blog/mqtt-keep-alive`,
      },
    ]
  }

  get helpPractice() {
    return [
      {
        icon: 'icon-java',
        title: 'Java',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-java`,
      },
      {
        icon: 'icon-nodejs',
        title: 'Node.js',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-nodejs`,
      },
      {
        icon: 'icon-go',
        title: 'Golang',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-golang`,
      },
      {
        icon: 'icon-python',
        title: 'Python',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-python`,
      },
      {
        icon: 'icon-php',
        title: 'PHP',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-php`,
      },
      {
        icon: 'icon-rust',
        invert: ['dark', 'night'],
        title: 'Rust',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-rust`,
      },
      {
        icon: 'icon-javascript',
        title: 'JavaScript',
        link: `${this.emqWebsite}/blog/mqtt-js-tutorial`,
      },
      {
        icon: 'icon-vue',
        title: 'Vue.js',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-vue`,
      },
      {
        icon: 'icon-react',
        title: 'React',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-react`,
      },
      {
        icon: 'icon-angular',
        title: 'Angular',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-angular`,
      },
      {
        icon: 'icon-websocket',
        invert: ['dark', 'night'],
        title: 'WebSocket',
        link: `${this.emqWebsite}/blog/connect-to-mqtt-broker-with-websocket`,
      },
      {
        icon: 'icon-electron',
        title: 'Electron',
        link: `${this.emqWebsite}/blog/how-to-use-mqtt-in-electron`,
      },
      {
        icon: 'icon-mini-program',
        title: this.$tc('help.miniProgram'),
        link: this.$i18n.locale === 'zh' ? `${this.emqWebsite}/blog/how-to-use-mqtt-in-wechat-miniprogram` : '',
      },
      {
        icon: 'icon-flutter',
        title: 'Flutter',
        link: `${this.emqWebsite}/blog/using-mqtt-in-flutter`,
      },
      {
        icon: 'icon-ios',
        invert: ['dark', 'night'],
        title: 'iOS',
        link: `${this.emqWebsite}/blog/ios-mqtt5-client`,
      },
      {
        icon: 'icon-android',
        title: 'Android',
        link: `${this.emqWebsite}/blog/android-connects-mqtt-using-kotlin`,
      },
      {
        icon: 'icon-raspberry-pi',
        title: this.$tc('help.raspberryPi'),
        link: `${this.emqWebsite}/blog/use-mqtt-with-raspberry-pi`,
      },
      {
        icon: 'icon-esp32',
        title: 'ESP32',
        link: `${this.emqWebsite}/blog/esp32-connects-to-the-free-public-mqtt-broker`,
      },
      {
        icon: 'icon-esp8266',
        title: 'ESP8266',
        link: `${this.emqWebsite}/blog/esp8266_mqtt_led`,
      },
    ]
  }

  private goToLink(url: string) {
    const windowUrl = window.open(url)
    if (windowUrl) {
      windowUrl.opener = null
    }
  }
}
